export const recentNotesNo = 3;  // Number of recent notes displayed
export const baseUrl = '/ver2';
export const apiTimeout = 20000;
export const apiUrl = 'https://platforma.szybkiangielski.pl/api';
export const staticsUrl = 'https://platforma.szybkiangielski.pl/api';
export const isDevelopment = false;
export const env = 'production';
export const img = (name) => `${baseUrl}/img/${name}`;
export const soundPath = (name) => `${baseUrl}/sounds/${name}`;
